export const qrConnect_arialabel = "cBa";
export default {qrConnect_arialabel};